// The key station-ops files a wallbox model under (its ModelKey): manufacturer
// and model compared regardless of case, surrounding space, runs of whitespace
// and the ® sign. Null when either part is empty, as station-ops does.

const normalise = (value: string | null | undefined): string =>
  (value ?? "").replace(/®/g, "").trim().replace(/\s+/g, " ").toLowerCase();

export const modelKey = (
  manufacturer: string | null | undefined,
  model: string | null | undefined
): string | null => {
  const m = normalise(manufacturer);
  const mo = normalise(model);
  return m && mo ? `${m}::${mo}` : null;
};
